export default __webpack_public_path__ + "static/media/finance-active.60b15d4d.svg";